

import axios from 'axios';
import {getToken, removeToken} from 'utils/auth'
import {router} from '@/routes/index'

import errorCode from '@/utils/errorCode'
import {messageError} from './common'
import {confirmError} from './common'
import {ElLoading} from "element-plus";

import {blobValidate, tansParams} from "./ai";
import { saveAs } from 'file-saver'
import {store} from "store";
axios.defaults.withCredentials = true;

// 基础地址
let baseURL = '/api';

console.log("process.env.mode.VITE_MODE----------------",import.meta.env.VITE_API,import.meta.env.VITE_MODE)
if (import.meta.env.VITE_MODE === 'direct_con') {
    baseURL = import.meta.env.VITE_API
}




console.log('baseURL',baseURL)
const service = axios.create({
    baseURL,
    withCredentials: true,
    timeout: 100000000000
});


// 请求拦截器
service.interceptors.request.use(config => {
    // 请求拦截器
    const isToken = (config.headers || {}).isToken === false
    const token = getToken() || ''
    if (token && !isToken) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    config.timeout=100000000000
    // console.log('config--------', config)
    if (config.method === 'get' && config.params) {
        let url = config.url + '?' + tansParams(config.params)
        url = url.slice(0, -1)
        config.params = {}
        config.url = url
    }
    return config;
}, error => {
    console.log(error);
    return Promise.reject(error);
});

// 响应拦截器
service.interceptors.response.use(async response => {
        // 未设置状态码则默认成功状态
        const code = response?.data?.code || 200
        // 获取错误信息
        const msg = errorCode[code] || response?.data?.msg || errorCode.default
        // 响应正确
        if (response.status >= 200 && response.status <= 210) {
            const data = response.data;

            // 登录过期
            if (data?.code === 401) {
                messageError(data?.msg || '登录过期，请重新登录')
                // 清除token
                await removeToken();
                router.replace('/login').catch(e => {
                    console.log(e);
                });
                return response?.data || false
            } else if(data?.code >= 500){

                let params = null
                if(response?.config?.params){
                    params = typeof response?.config?.params === 'object' ? JSON.stringify(response?.config?.params) : response?.config?.params
                }

                console.log(response,'response')

                confirmError(`
                     <p><span style='font-weight:bold'>接口地址：</span><span style='color:red'>${response?.config?.url || null}</span></p>
                     <p><span style='font-weight:bold'>请求参数: </span><span style='color:red'>${params || null}</span></p>
                     <p><span style='font-weight:bold'>报错信息: </span><span style='color:red'>${response?.data?.msg || ''}</span></p>
                    `)
                return Promise.reject(new Error(msg))
            } else if(code !== 200){
                messageError(data?.msg ||data?.message|| '网络异常')
                return
            } else {
                return response.data
            }
        }

    },
    error => {
        // console.log(error,'error===123')
        console.log(error.request, error?.response,'error?.request')
        const status = error?.response?.status;
        const data = error?.response?.data;
        confirmError(`
          <p><span style='font-weight:bold'>接口地址：</span><span style='color:red'>${decodeURIComponent(error?.request?.responseURL) || null}</span></p>
          <p><span style='font-weight:bold'>错误码: </span><span style='color:red'>${error?.request?.status ?? null}</span></p>
          <p><span style='font-weight:bold'>报错信息: </span><span style='color:red'>${error?.message || null}</span></p>
        `)
        return Promise.reject(error)

        // 过期/账号封停等
        // if (status === 401) {
        //     removeToken();
        //     router.replace('/login').catch(e => {
        //         console.log(e);
        //     });
        //
        //     return data;
        // } else {
        //     return Promise.resolve(error?.message);
        // }
    });

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function get(url, params = {}) {
    try {
        return service({
            url,
            params,
            method: 'GET'
        });
    } catch (error) {
        console.error('get:', error);
    }
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(url, data = {},timeout=600000) {

    try {
        return service({
            url,
            method: 'POST',
            data,
            timeout
        });
    } catch (error) {
        console.error('post:', error);
    }
}

/**
 * 封装PUT请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function put(url, data = null) {
    try {
        return service({
            url,
            method: 'PUT',
            data
        });
    } catch (error) {
        console.error('put:', error);
    }
}

export function del(url, data = {}) {
    try {
        return service({
            url,
            method: 'delete',

        });
    } catch (error) {
        console.error('delete:', error);
    }
}



// 通用下载方法
export const download = async (url, params, filename) => {
    let downloadLoadingInstance = ElLoading.service({ text: '正在下载数据，请稍候', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })

    return service.post(url, params, {
        transformRequest: [(params) => { return tansParams(params) }],
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        responseType: 'blob'
    }).then(async (data) => {
        console.log(data,'data返回的')
        const isLogin = await blobValidate(data)
        console.log(isLogin,'isLogin')
        if (isLogin) {
            const blob = new Blob([data])
            saveAs(blob, filename)
        } else {
            const resText = await data.text()
            const rspObj = JSON.parse(resText)
            const errMsg = errorCode[rspObj.code] || rspObj?.msg || errorCode.default
            messageError(errMsg)
        }
        downloadLoadingInstance.close()
    }).catch((error) => {
        console.error(error,'下载error')
        const status = error?.response?.status;
        const data = error?.response?.data;
        confirmError(`
          <p><span style='font-weight:bold'>接口地址：</span><span style='color:red'>${decodeURIComponent(error?.request?.responseURL) || null}</span></p>
          <p><span style='font-weight:bold'>错误码: </span><span style='color:red'>${error?.request?.status || null}</span></p>
          <p><span style='font-weight:bold'>报错信息: </span><span style='color:red'>${error?.message || null}</span></p>
        `)
        downloadLoadingInstance.close()
        return Promise.reject(error)
    })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function postFormData(url, data = {},headers={}) {
    try {
        return service({
            url,
            method: 'POST',
            data,
            headers
        });
    } catch (error) {
        console.error('post:', error);
    }
  }